import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { exchangeCode } from '../api/auth';
import { supabase } from '../lib/supabase';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const qs = new URLSearchParams(window.location.search);
      const from = qs.get('from');
      const code = qs.get('code');
      const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
      const tokenFromHash = hash.get('access_token');

      try {
        // Signup doğrulaması ise login'e zorla
        if (from === 'signup') {
          try { await supabase.auth.signOut(); } catch (_) {}
          navigate('/login?verified=1', { replace: true });
          return;
        }

        let tokens = null;
        if (code) {
          const r = await exchangeCode(code);
          tokens = await r.json();
        } else if (tokenFromHash) {
          tokens = {
            access_token: tokenFromHash,
            refresh_token: hash.get('refresh_token'),
          };
        }

        if (tokens?.access_token) {
          try {
            await supabase.auth.setSession({
              access_token: tokens.access_token,
              refresh_token: tokens.refresh_token || '',
            });
          } catch (_) {}
          navigate('/dashboard', { replace: true });
        } else {
          navigate('/login', { replace: true });
        }
      } catch (_) {
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate]);

  return <div style={{ padding: 24 }}>Giriş yapılıyor…</div>;
}


